<span [attr.class]="cssClass">{{ money.toStringCompactWithCoin() }}</span>
